import OrderCostSummaryPdfV3 from "../OrderCostSummaryPdfV3";

const OrderCostSummaryPdfV4 = OrderCostSummaryPdfV3;

export default OrderCostSummaryPdfV4;
